import { useEffect, useRef } from 'react';

export default function usePreviousRoute(location: any) {
    const ref = useRef();
    useEffect(() => {
        ref.current = location;
    }, [location]);
    return ref.current;
}
